module.exports = __webpack_public_path__ + "static/media/08.08312533.mp3";